import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ConsultationSection from "./components/ConsultationSection";
import ArtEventSection from "./components/ArtEventSection";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ConsultationSection />
        <ArtEventSection />
      </main>
      <Footer />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
